import { formatPriceWithCurrencySymbol } from "../../../helpers/getPriceWithCurrencySymbol";
import BookingGetters from "../../../store/onlineBooking/getters";
import React, { useEffect } from "react";
import theme from "../../../config/MuiColorThemes";
// import { Card } from "@mui/material";
import Card from "@mui/material/Card";
// import { SelectVehicleExtrasProps } from "../../Layouts/VehicleExtraSelections/SelectVehicleExtras.props";
// import { TextResource } from "../../../@types/DTO/AppSetting";
// import { useTranslation } from "react-i18next";

function VehicleExtraOptions({
  iconUrl,
  optionName,
  pricePerDayInUSD,
  details,
  onDecrementClick,
  onIncrementClick,
  value,
  selectedCardBackgroundColor,
  selectedCardTextColor,
  applyRateOptionalBooking,
}): JSX.Element {
  const buttonBorderStyles =
    "border-solid border-black-300 border-2 rounded-lg ";
  const appSettings = BookingGetters.getAppSettings();
  // const textResource = BookingGetters.getTextResource();
  // const data: TextResource[] = textResource?.data ?? [];
  // const optionalObject = data.find((item) => item.key === optionName);
  // const optionalBody = optionalObject ? optionalObject?.body : "";
  // const { t: translate } = useTranslation();
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    if (
      (optionName === "WEEKEND-NEW" && applyRateOptionalBooking) ||
      pricePerDayInUSD == 0
    ) {
      onIncrementClick();
    }
  }, [optionName]);
  const isIphoneScreen = window.innerWidth >= 400 && window.innerWidth <= 768;
  return (
    <Card
      className={``}
      sx={{
        width: !isSmallScreen ? "314px" : isIphoneScreen ? "350px" : "320px",
        height: !isSmallScreen ? "262px" : "120px",
        borderRadius: theme.shape.borderRadius,
        borderTop: !isSmallScreen ? "1px solid #B3B3B3" : "#B3B3B3",
        margin: 1,
      }}
    >
      <div
        className="w-full h-full"
        style={
          !isSmallScreen
            ? { marginTop: "34px", marginLeft: "29px" }
            : { marginLeft: !isSmallScreen ? "29px" : "" }
        }
      >
        <div className=" flex flex-row mt-[10px] md:mt-0 md:flex-col">
          {iconUrl != "#" && appSettings?.showHideExtrasImages && (
            <img
              src={iconUrl}
              style={{ width: "34px", height: "35.45px" }}
              className={`w-full aspect-square ${
                isSmallScreen ? "ml-[10px]" : ""
              }`}
              alt="icon"
            />
          )}

          <main
            className={`flex flex-col box-border grow max-w-[80%] grow text-sm relative ${
              isSmallScreen ? "ml-[10px]" : ""
            }`}
            style={{
              marginTop: "10.98px",
              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            }}
          >
            <span className="break-words" style={{ fontSize: "26px" }}>
              {optionName}
            </span>
            <span
              className="break-words"
              style={{
                fontFamily: "MBCorpoSText-Regular-Web-new",
                fontSize: "15px",
                textTransform: "lowercase",
                marginTop: "5.56px",
              }}
            >
              {details}
            </span>
          </main>
        </div>
        <div
          className={`flex flex-row items-center ${
            isSmallScreen ? "ml-[10px]" : ""
          }`}
          style={{
            marginTop: !isSmallScreen ? "40px" : "",
            justifyContent: "space-between",
            marginRight: "49px",
          }}
        >
          <div>
            {pricePerDayInUSD > 0 ? (
              <span
                style={{
                  fontFamily: "MBCorpoSText-Regular-Web-new",
                  fontSize: "30px",
                  fontWeight: "bold",
                }}
              >
                {pricePerDayInUSD}
                {
                  formatPriceWithCurrencySymbol(BookingGetters.getCurrency())
                    .symbol
                }
                {/*<span style={{ fontSize: "15px" }}>*/}
                {/*{translate("/per day")}*/}
                {/*</span>*/}
              </span>
            ) : (
              //empty div to take up the space for price per day
              <div
                style={{
                  fontFamily: "MBCorpoSText-Regular-Web-new",
                  fontSize: "30px",
                  fontWeight: "bold",
                  visibility: "hidden",
                }}
              >
                {/*<span style={{ fontSize: "15px" }}>*/}
                {/*{translate("/per day")}*/}
                {/*</span>*/}
              </div>
            )}
          </div>

          <div
            className={`flex flex-row items-center ${
              optionName === "WEEKEND-NEW" ? "ml-[0rem]" : "ml-10 md:ml-4"
            }`}
          >
            <div
              onClick={() => {
                (optionName === "WEEKEND-NEW" && applyRateOptionalBooking) ||
                pricePerDayInUSD == 0
                  ? ""
                  : onDecrementClick();
              }}
              className={
                "w-6 h-6 flex items-center justify-center select-none" +
                " " +
                buttonBorderStyles
              }
              style={{
                backgroundColor: "#D9D9D9",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                fontSize: "23px",
                color: "#000",
                lineHeight: "1",
                cursor:
                  (optionName === "WEEKEND-NEW" && applyRateOptionalBooking) ||
                  pricePerDayInUSD == 0
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              -
            </div>
            <span
              className="flex items-center justify-center mx-2"
              style={{
                fontFamily: "MBCorpoSText-CondRegular-Web",
                fontSize: "17px",
              }}
            >
              {value}
            </span>
            <div
              onClick={() => {
                (optionName == "WEEKEND-NEW" && applyRateOptionalBooking) ||
                pricePerDayInUSD == 0
                  ? ""
                  : onIncrementClick();
              }}
              className={
                "w-6 h-6 flex items-center justify-center select-none" +
                " " +
                buttonBorderStyles
              }
              style={{
                backgroundColor:
                  value > 0 ? selectedCardBackgroundColor : "#D9D9D9",
                color: value > 0 ? selectedCardTextColor : "",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                fontSize: "23px",
                cursor:
                  (optionName === "WEEKEND-NEW" && applyRateOptionalBooking) ||
                  pricePerDayInUSD == 0
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              <span className="w-fit h-fit black">+</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
export { VehicleExtraOptions };
export { VehicleExtraOptions as default };
